import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { acceptInvite, checkInviteToken } from '../../../../api/auth';
import { LOGIN_PATH } from '../../../../constants/routes';
import { GENERAL_ERROR_MESSAGE } from '../../../../constants/texts';
import { useCheckingToken } from '../../../../hooks/useCheckingToken';
import { useSnackbar } from '../../../../hooks/useSnackbar';
import { useCountries } from '../../Admin/GuestPortal/GuestForms/functions';
import getValidationSchema from './validationSchema';

export const useInvitationPasswordForm = () => {
  const { countries } = useCountries();
  const onSnackbar = useSnackbar();

  const handleError = (error) => {
    if (error?.errors?.status === 404) {
      onSnackbar(error?.errors?.title ?? GENERAL_ERROR_MESSAGE);
      window.location.replace(LOGIN_PATH);
    }
  };
  const { token } = useParams();

  const { isPending, data, error } = useCheckingToken(token, checkInviteToken, { onError: handleError });

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    resolver: yupResolver(getValidationSchema(data?.subUser)),
    mode: 'onChange',
  });

  const onSubmit = async (values) => {
    acceptInvite({ token, ...values }).then(() => window.location.replace(LOGIN_PATH));
  };

  const handleCountryChange = (onChange) => (id, name) => {
    onChange(name);
  };

  const loadCountries = (e) => countries.filter(({ label }) => label.toLowerCase().includes(e.toLowerCase()));

  const colors = ['sky', 'purple', 'peach', 'yellow', 'red', 'blue', 'beige', 'pink', 'green'];

  return {
    isPending,
    data,
    colors,
    error,
    handleSubmit: handleSubmit(onSubmit),
    handleCountryChange,
    loadCountries,
    isValid,
    control,
  };
};
